export function deepCopy(originalArray) {
  return JSON.parse(JSON.stringify(originalArray));
}
